import { render } from "./NotificationOptions.vue?vue&type=template&id=531dc598"
import script from "./NotificationOptions.vue?vue&type=script&lang=js"
export * from "./NotificationOptions.vue?vue&type=script&lang=js"
script.render = render

export default script